/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import find from 'lodash/find';
import {
  Typography,
  Grid,
  Checkbox,
  Button,
  MenuItem,
  Select,
  InputBase,
  Icon,
} from '@material-ui/core';
import { KeyboardArrowRight } from '@material-ui/icons';
import _, { cloneDeep } from 'lodash';
import LoadingBar from '../share/LoadingBar';
import ProductCard from './ProductCard';
import BasicToolBar from '../share/BasicToolBar';
import DeleteConfirmDialog from '../share/DeleteConfirmDialog';
import GeneralDialog from '../share/GeneralDialog';
import { bulkActions } from '../../data/Constants';
import { getLocationIdOfAuthorizationOrAdmin } from '../../utils/AuthorizationChecks';
import { searchEntity } from '../../utils/Functions';
import {
  commonResourceStyle,
  generalDialogStyles,
  deleteConfirmationDialogStyles,
  displayResourceStyles,
  v2DropdownStyles,
  searchComponentStyles,
} from '../../css/style';

const dropdownStyles = v2DropdownStyles();
const searchStyles = searchComponentStyles();
const styles = commonResourceStyle();
const bulkActionStyles = generalDialogStyles();
const actionConfirmStyles = deleteConfirmationDialogStyles();
const displayStyles = displayResourceStyles();

class Items extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleteConfirmDialogOpen: false,
      dataInDeleteConfirmDialog: null,
      isBulkActionConfirmDialogOpen: false,
      selectedBulkAction: '',
      selectedBulkOutOfStockLocations: [],
      filteredCategory: [],
      filteredProduct: [],
      searchedProduct: [],
      searchedAndFilteredProduct: [],
      locationIds: [],
      categoryIds: [],
      searchedTerm: null,
      applyCategoryFilter: false,
      applyProductFilter: false,
    };
  }

  componentDidMount() {
    this.getMenuResources();
  }

  componentDidUpdate(prevProps) {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      this.getMenuResources(true);
    }
  }

  getMenuResources = async (forceFetch = false) => {
    const {
      actions, apiToken, categories, locations, products,
    } = this.props;
    // Request locations because if you come from the Locations page
    // that puts a subset of all locations in the Redux store,
    // while the component instead needs the full list for its display out of stock status logic
    if (!locations || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) actions.getAllResources(apiToken, 'locations');
    if (!categories || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) await actions.getAllResources(apiToken, 'categories');
    if (!products || forceFetch || get(this.props, 'location.state.fromCreateAndEditResource')) await actions.getAllResources(apiToken, 'products');
  }

  filterProducts = (products, categories) => {
    const result = categories.map((category) => {
      const temp = products.filter(product => category.id === product.category.id);
      return temp;
    });
    return result;
  }

  onClickEdit = (data) => {
    const {
      actions, match, history,
    } = this.props;
    const { resource, resourceId } = match.params;
    actions.clearErrors();
    const resourceName = 'products';
    if (resourceId) {
      history.push(`/${resource}/${resourceId}/${resourceName}/${data.id}/edit`);
    } else {
      history.push(`/${resourceName}/${data.id}/edit`);
    }
  }

  onClickDelete = async (data) => {
    this.setState({
      isDeleteConfirmDialogOpen: true,
      dataInDeleteConfirmDialog: data,
    });
  }


  onClickDuplicateProduct = () => {
    this.getMenuResources(true).then(() => {
      this.updateProductLists('duplicate');
    });
  }

  updateProductLists = (action, dataId = 0) => {
    const { searchedTerm, applyProductFilter } = this.state;
    if (searchedTerm) {
      this.setState(prevState => ({
        searchedProduct:
          this.updateProductList(action, prevState.searchedProduct, dataId),
        searchedAndFilteredProduct:
          this.updateProductList(action, prevState.searchedAndFilteredProduct, dataId),
      }));
    }
    if (applyProductFilter) {
      this.setState(prevState => ({
        filteredProduct: this.updateProductList(action, prevState.filteredProduct, dataId),
      }));
    }
  }

  updateProductList = (action, productList, dataId) => {
    if (action === 'duplicate') {
      const { products } = this.props;
      const dupProduct = cloneDeep(products[products.length - 1]);
      return [...productList, dupProduct];
    }
    return productList.filter(product => product.id !== dataId);
  }

  getTargetResourceNames = (action) => {
    const { isDeleteConfirmDialogOpen, dataInDeleteConfirmDialog } = this.state;
    if (action === 'delete' && isDeleteConfirmDialogOpen) return dataInDeleteConfirmDialog.name;
    return '';
  }

  onClickConfirmDeleteButton = async () => {
    const {
      actions, apiToken, onClickDeleteResource,
    } = this.props;
    const resource = 'products';
    const data = this.state.dataInDeleteConfirmDialog;
    actions.clearErrors();

    if (typeof onClickDeleteResource === 'function') {
      onClickDeleteResource(data.id);
      this.onCloseDialog();
      return;
    }
    actions.deleteResource(apiToken, resource, data.id).then(() => {
      this.updateProductLists('delete', data.id);
    });
    this.onCloseDialog();
  }

  onCloseDialog = () => {
    this.setState({ isDeleteConfirmDialogOpen: false, isBulkActionConfirmDialogOpen: false });
  }

  onClickAddResourceOverride = () => {
    const {
      actions, history,
    } = this.props;
    actions.clearErrors();
    history.push('products/create');
  }

  isCheckedCategory = (category) => {
    const { products, selectedItems } = this.props;
    const categoryProducts = products.filter(
      product => category[0].category.id === product.category.id,
    );
    if (!selectedItems) {
      return false;
    }
    return categoryProducts.every(product => selectedItems.includes(product));
  }

  isCheckedProduct = (product) => {
    const { selectedItems } = this.props;
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(product);
  }

  onSelectItem = (event, item) => {
    const { actions } = this.props;
    if (event.target.checked) {
      actions.selectItems(item);
    } else {
      actions.unselectItems(item);
    }
  }

  onBulkActionDropdownChange = (event) => {
    const { selectedItems } = this.props;
    const { value } = event.target;
    if (Object.keys(bulkActions).includes(value)
      && find(selectedItems, isChecked => !!isChecked)) {
      this.setState({
        isBulkActionConfirmDialogOpen: true,
        selectedBulkAction: value,
      });
    }
  }

  getBulkOutOfStockLocations = (p, admin) => {
    const { selectedBulkOutOfStockLocations } = this.state;
    const outOfStockLocationsClone = p.outOfStockLocations.slice();

    const adminLocationId = getLocationIdOfAuthorizationOrAdmin('locations', admin);
    const withAdminLocation = outOfStockLocationsClone.includes(adminLocationId)
      ? outOfStockLocationsClone
      : [...outOfStockLocationsClone, adminLocationId];

    // Location admins can only add their locations. Normal admins instead do a "set" operation.
    const newOutOfStockLocations = adminLocationId
      ? withAdminLocation
      : selectedBulkOutOfStockLocations;
    return newOutOfStockLocations;
  }

  assignOutOfStockLocations = (locations, isSingleLocation, authorizedLocations) => (
    { outOfStockLocations: isSingleLocation ? [locations[0].id] : authorizedLocations }
  )

  assignInStockLocations = (isSingleLocation, payload, selectedLocations) => (
    {
      outOfStockLocations: isSingleLocation ? []
        : payload.outOfStockLocations.filter(item => !selectedLocations.includes(item)),
    }
  )

  onClickConfirmBulkAction = () => {
    const { selectedBulkAction, selectedBulkOutOfStockLocations } = this.state;
    const {
      actions,
      apiToken,
      locations,
      admin,
      selectedItems,
    } = this.props;
    if (selectedBulkAction === '') {
      this.setState({ isBulkActionConfirmDialogOpen: false });
      return;
    }
    this.setState({ isBulkActionConfirmDialogOpen: false });
    const isSingleLocation = locations && locations.length === 1;
    if (Object.keys(bulkActions).includes(selectedBulkAction)) {
      const payload = selectedItems
        .map((p) => {
          const basePayload = { id: p.id };
          if (selectedBulkAction === 'outOfStock') {
            const newOutOfStockLocations = this.getBulkOutOfStockLocations(p, admin);
            Object.assign(basePayload,
              this.assignOutOfStockLocations(locations, isSingleLocation, newOutOfStockLocations));
          } else if (selectedBulkAction === 'inStock') {
            Object.assign(basePayload,
              this.assignInStockLocations(isSingleLocation, p, selectedBulkOutOfStockLocations));
          }
          return basePayload;
        });
      actions.unselectAllItems();
      actions.updateResource(apiToken, payload, 'products', bulkActions[selectedBulkAction].uri).then(() => {
        actions.getAllResources(apiToken, 'products');
      });
    }
  }

  bulkActionConfirmCancelButtons = () => {
    const { selectedBulkAction, selectedBulkOutOfStockLocations } = this.state;
    const { locations } = this.props;
    const disableAction = ['outOfStock', 'inStock'].includes(selectedBulkAction)
      && locations
      && locations.length > 1
      && selectedBulkOutOfStockLocations.length === 0;

    return (
      <div>
        <Button
          style={actionConfirmStyles.confirmButton}
          onClick={this.onClickConfirmBulkAction}
          disabled={disableAction}
        >
          {bulkActions[selectedBulkAction].dialogBtnText.replace(/#RESOURCE#/g, 'products').toUpperCase()}
        </Button>
        <Typography
          style={actionConfirmStyles.cancelText}
          onClick={this.onCloseDialog}
        >
          Cancel
        </Typography>
      </div>
    );
  }

  renderBulkOutOfStockLocationDropdown = () => {
    const { locations, admin } = this.props;
    const { selectedBulkOutOfStockLocations } = this.state;
    const adminLocationId = getLocationIdOfAuthorizationOrAdmin('locations', admin);

    const authorizedLocations = locations.filter(
      loc => !adminLocationId || loc.id === Number(adminLocationId),
    );
    return (
      <Select
        value={selectedBulkOutOfStockLocations}
        style={{ ...styles.bulkActionDropdown, width: '100%' }}
        input={<InputBase />}
        displayEmpty
        multiple
        onChange={e => this.setState({ selectedBulkOutOfStockLocations: e.target.value })}
      >
        <MenuItem value='placeholder' disabled>Please Select...</MenuItem>
        {
          authorizedLocations.map(location => (
            <MenuItem
              key={location.id}
              value={location.id}
            >
              {location.name}
            </MenuItem>
          ))
        }
      </Select>
    );
  }

  bulkActionMessage = () => {
    const { selectedBulkAction } = this.state;
    const { locations, selectedItems } = this.props;
    const targetResources = selectedItems;
    const targetResourceNames = Array.isArray(targetResources)
      ? targetResources.map(resource => (
        <div key={resource.id} style={bulkActionStyles.truncatedBulkTargetResourceName}>
          {resource.name}
        </div>
      ))
      : [];
    const targetResourcesContainerStyle = targetResourceNames.length < 6
      ? actionConfirmStyles.bulkTargetResources
      : actionConfirmStyles.bulkTargetResourcesWithVertScrollbar;
    const shouldShowSelectLocation = ['outOfStock', 'inStock'].includes(selectedBulkAction)
      && locations
      && locations.length > 1;

    return (
      <div style={bulkActionStyles.messageAndTargetResourcesContainer}>
        {
          shouldShowSelectLocation
          && (
            <div>
              <Typography style={bulkActionStyles.bulkActionAreYouSureQuestion}>
                {bulkActions[selectedBulkAction].dialogSlectText}
              </Typography>
              {this.renderBulkOutOfStockLocationDropdown()}
            </div>
          )
        }
        <Typography style={bulkActionStyles.bulkActionAreYouSureQuestion}>
          {bulkActions[selectedBulkAction].dialogConfirmText.replace(/#RESOURCE#/g, 'products')}
        </Typography>
        <div style={targetResourcesContainerStyle}>
          {targetResourceNames}
        </div>
      </div>
    );
  }

  renderCategory = (category) => {
    const {
      actions, apiToken, match, selectedItems,
    } = this.props;
    return category[0] && (
      <div
        style={styles.categoryContainer}
        ref={(el) => { this[`${category[0].category.id}`] = el; }}
      >
        <div style={styles.categoryHeaderContainer}>
          <Checkbox
            style={styles.itemsHeaderCheckBox}
            onChange={event => this.onSelectItem(event, category)}
            checked={this.isCheckedCategory(category)}
            icon={(
              <Icon style={displayStyles.uncheckedCheckboxIcon}>
                check_box_outline_blank
              </Icon>
            )}
            checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
          />
          <Typography style={styles.itemsCategoryTitle}>
            {category[0].category.name.toUpperCase()}
          </Typography>
        </div>
        <div style={styles.itemsListContainer}>
          {category.map(product => (
            <ProductCard
              product={product}
              onClickEdit={() => this.onClickEdit(product)}
              actions={actions}
              apiToken={apiToken}
              match={match}
              onClickDelete={() => this.onClickDelete(product)}
              onClickDuplicate={this.onClickDuplicateProduct}
              selectedItems={selectedItems}
              isChecked={() => this.isCheckedProduct(product)}
            />
          ))}
        </div>
      </div>
    );
  }

  handleSearch = (term, isFilter = true) => {
    const { products } = this.props;
    const { applyProductFilter, filteredProduct } = this.state;
    const filterProducts = (isFilter && applyProductFilter) ? filteredProduct : products;
    const searchEntityResult = searchEntity(term, filterProducts, 'name');
    this.setState({
      searchedTerm: term,
      searchedAndFilteredProduct: searchEntityResult,
      searchedProduct: searchEntityResult,
    });
  }

  handleClearSearch = () => {
    this.setState({
      categoryIds: [],
      applyCategoryFilter: false,
      applyProductFilter: false,
      searchedTerm: null,
    });
  }

  filterByCheckedEntities = (entities, entityIds, entityName) => {
    const { searchedTerm } = this.state;
    let filteredEntities;
    if (entityName === 'Category') {
      filteredEntities = entities.filter(entity => entityIds.includes(entity.id));
    } else {
      filteredEntities = entities.filter(entity => (
        entity.locations && entity.locations.some(locationId => entityIds.includes(locationId))
      ));
    }
    this.setState({
      [`apply${entityName}Filter`]: true,
    });
    if (entityName === 'Product' && searchedTerm) {
      this.setState({ searchedAndFilteredProduct: filteredEntities });
    } else {
      this.setState({ [`filtered${entityName}`]: filteredEntities });
    }
  }

  onChangeSelect = (entities, entityIds, entityName) => {
    const { searchedTerm } = this.state;
    const capitalizedEntity = _.capitalize(entityName);
    if (entityIds.length === 0) {
      this.setState({ [`apply${capitalizedEntity}Filter`]: false });
      if (searchedTerm) {
        this.handleSearch(searchedTerm, false);
      }
      return;
    }
    this.filterByCheckedEntities(entities, entityIds, capitalizedEntity);
  }

  renderSelectComponent = (entities, entityIds, entityName, label) => {
    let entitiesValue = entities;
    let entityNameValue = entityName;
    return (
      <Select
        value={entityIds}
        style={dropdownStyles.dropdownItemsOuterContainer}
        input={<InputBase />}
        displayEmpty
        multiple
        onChange={(e) => {
          this.setState({ [`${entityName}Ids`]: e.target.value });
          if (entityName === 'location') {
            entitiesValue = this.getProductsToFilter();
            entityNameValue = 'product';
          }
          this.onChangeSelect(entitiesValue, e.target.value, entityNameValue);
        }}
        IconComponent={KeyboardArrowRight}
        renderValue={selected => (
          selected.length === 0
            ? label
            : entities.filter(entity => selected.includes(entity.id)).map(entity => entity.name).join(', ')
        )}
      >
        {
          entities && entities.map(entity => (
            <MenuItem style={styles.menuItem} key={entity.id} value={entity.id}>
              <Checkbox
                checked={entityIds.indexOf(entity.id) > -1}
                style={styles.checkbox}
              />
              {entity.name}
            </MenuItem>
          ))
        }
      </Select>
    );
  }

  onSelectAll = (event) => {
    const { products, actions } = this.props;
    if (event.target.checked) {
      actions.selectAllItems(products);
    } else {
      actions.unselectAllItems();
    }
  }

  getProductArray = () => {
    const { products } = this.props;
    const { searchedTerm, applyProductFilter } = this.state;
    const { filteredProduct, searchedProduct, searchedAndFilteredProduct } = this.state;
    let product;
    if (searchedTerm && applyProductFilter) {
      product = searchedAndFilteredProduct;
    } else if (searchedTerm) {
      product = searchedProduct;
    } else if (applyProductFilter) {
      product = filteredProduct;
    } else {
      product = products;
    }
    return product;
  }

  getProductsToFilter = () => {
    const { products } = this.props;
    const { searchedTerm, searchedProduct } = this.state;
    if (searchedTerm) {
      return searchedProduct;
    }
    return products;
  }

  render() {
    const {
      actions, loading, categories, locations,
    } = this.props;
    const {
      isBulkActionConfirmDialogOpen,
      selectedBulkAction,
      isDeleteConfirmDialogOpen,
      filteredCategory,
      locationIds,
      categoryIds,
      applyCategoryFilter,
    } = this.state;
    const filterCategories = applyCategoryFilter ? filteredCategory : categories;
    const filterProducts = this.getProductArray();
    const filteredProducts = (filterProducts && filterCategories)
      && this.filterProducts(filterProducts, filterCategories);
    return (
      (loading === true || !filterCategories || !filteredProducts)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Items</Typography>
              </div>
            </div>
            <div style={styles.innerContainer}>
              <div style={styles.resourceHeader}>
                <BasicToolBar
                  actions={actions}
                  resourceName="products"
                  handleSearch={this.handleSearch}
                  handleClearSearch={this.handleClearSearch}
                  onClickAddResourceOverride={this.onClickAddResourceOverride}
                  isBulkActions
                  onBulkActionDropdownChange={this.onBulkActionDropdownChange}
                >
                  {this.renderSelectComponent(categories, categoryIds, 'category', 'Categories')}
                  {this.renderSelectComponent(locations, locationIds, 'location', 'Available at')}
                </BasicToolBar>
              </div>
              <div style={styles.selectAllCheckboxContainer}>
                <Checkbox
                  style={styles.selectAllCheckBox}
                  onChange={this.onSelectAll}
                  icon={(
                    <Icon style={displayStyles.uncheckedCheckboxIcon}>
                      check_box_outline_blank
                    </Icon>
                  )}
                  checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
                />
                <Typography style={styles.selectAllText}>Select All</Typography>
                <Typography style={styles.itemsHeaderText}>ITEM</Typography>
                <Typography style={styles.itemsHeaderText}>AVAILABLE AT</Typography>
                <Typography style={styles.itemsHeaderText}>OUT OF STOCK AT</Typography>
                <Typography style={styles.itemsHeaderPrice}>PRICE</Typography>
                <div style={styles.itemsHeaderThreeDot} />
              </div>
              <div style={styles.categoryHeaderBorderStyle} />
              <div style={styles.itemsContainer}>
                <Grid
                  container
                  direction='column'
                  style={styles.gridBackground}
                >
                  {
                    filteredProducts
                    && filteredProducts.map(category => this.renderCategory(category))
                  }
                </Grid>
              </div>
              <DeleteConfirmDialog
                resourceName='items'
                isDialogOpen={isDeleteConfirmDialogOpen}
                deleteDataName={this.getTargetResourceNames('delete')}
                onCloseDialog={this.onCloseDialog}
                onClickConfirmButton={this.onClickConfirmDeleteButton}
              />
              {selectedBulkAction && (
                <GeneralDialog
                  type="bulkAction"
                  open={isBulkActionConfirmDialogOpen}
                  onClose={this.onCloseDialog}
                  contentContainerStyle={bulkActionStyles.bulkActionDialogContainer}
                  title={bulkActions[selectedBulkAction].dialogTitle.replace(/#RESOURCE#/g, 'items').toUpperCase()}
                  message={this.bulkActionMessage()}
                  buttons={this.bulkActionConfirmCancelButtons()}
                />
              )}
            </div>
          </div>
        )
    );
  }
}

Items.propTypes = {
  loading: PropTypes.bool.isRequired,
  admin: PropTypes.objectOf(PropTypes.any).isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  locations: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  categories: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  onClickDeleteResource: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
};

Items.defaultProps = {
  products: null,
  locations: null,
  categories: null,
};

export default withRouter(Items);
